import { useNavigate } from 'react-router-dom';
import { shouldSubmitSearch } from '../searchSubmit';
import { useLandingCategories } from '../useLandingCategories';
import { isDealsOfTheDayHomeEnabled, LANDING_SEO_TITLE } from '../homepageConfig';
import { LogoMark } from './LogoMark';
import { SearchField } from './SearchField';
import { SearchStatsLine } from './SearchStatsLine';
import { CategoryList } from './CategoryList';
import { SiteFooter } from './SiteFooter';
import { PageHead } from './PageHead';
import { DEFAULT_DESCRIPTION, HOME_WEBSITE_JSON_LD } from '../seo';
import './SearchResultsPage.css';
import './LandingPage.css';

export function LandingPageClassic() {
  const navigate = useNavigate();
  const {
    categories,
    comingSoonCategories,
    categoriesLoading,
    categoriesError,
  } = useLandingCategories();
  const showDealsOfTheDayHome = isDealsOfTheDayHomeEnabled();

  function goToSearch(query) {
    const trimmed = typeof query === 'string' ? query.trim() : '';
    if (!shouldSubmitSearch(trimmed)) {
      return;
    }
    navigate(`/search?q=${encodeURIComponent(trimmed)}`);
  }

  const footerCategories = [...categories, ...comingSoonCategories];

  return (
    <>
      <PageHead
        title="Compare products from online shops in Malta | Shops.mt"
        description={DEFAULT_DESCRIPTION}
        canonicalPath="/"
        jsonLd={HOME_WEBSITE_JSON_LD}
      />
      <main className="landing">
        <div className="landing__stack">
          <div className="landing__logo-wrap">
            <LogoMark />
            <p className="landing__since">since 2026</p>
          </div>
          <SearchField onSubmitSearch={goToSearch} gaSearchLocation="home" />
          <h1 className="landing__seo-title">{LANDING_SEO_TITLE}</h1>
          <SearchStatsLine />
        </div>
        <CategoryList
          categories={categories}
          comingSoonCategories={comingSoonCategories}
          categoriesLoading={categoriesLoading}
          errorMessage={categoriesError}
          showDealsOfTheDayHome={showDealsOfTheDayHome}
        />
      </main>
      <SiteFooter browseCategories={footerCategories} />
    </>
  );
}
